<template>
  <div class="formLogin">
    <a-form-model :model="form" @submit.prevent>
      <a-form-model-item>
        <a-input v-model="form.phone" size="large" maxlength="11"
          placeholder="请输入手机号" :disabled="busy" />
      </a-form-model-item>
      <div class="captcha">
        <a-form-model-item>
          <a-input :value="form.verifyCode" size="large" :max-length="6"
          @input="onVerifyCodeInput"
          placeholder="请输入验证码" :disabled="busy">
          <a-button slot="addonAfter" class="captchaButton" :disabled="busy || sending || remaining > 0"
            @click="sendCode">
            {{ remaining > 0 ? `${remaining}s` : '获取验证码' }}
          </a-button>
        </a-input>
        </a-form-model-item>
      </div>
      <Environment />
      <a-button class="button" :loading="busy" :disabled="sending" @click="submit">
        登&nbsp;录
      </a-button>
    </a-form-model>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import { rmToken } from '@/utils/authStorage';
import Environment from '@/views/login/components/environment.vue';
import { sendUnifiedVerifyCode, loginUnifiedSms } from '../login';

export default {
  name: 'CmhubLogin',
  components: { Environment },
  data() {
    return {
      form: { phone: '', verifyCode: '' },
      codeId: '',
      codePhone: '',
      codeEnv: '',
      busy: false,
      sending: false,
      remaining: 0,
      timer: null,
    };
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  },
  methods: {
    onVerifyCodeInput(event) {
      const value = event.target.value.replace(/\D/g, '').slice(0, 6);
      this.form.verifyCode = value;
      // 清理粘贴和输入法输入，并同步输入框可见值。
      event.target.value = value;
    },
    async sendCode() {
      if (this.busy || this.sending || this.remaining > 0) return;
      this.sending = true;
      this.codeId = '';
      const phone = this.form.phone.trim();
      const env = localStorage.getItem('curEnv') || '';
      try {
        this.codeId = await sendUnifiedVerifyCode(phone);
        this.codePhone = phone;
        this.codeEnv = env;
        this.remaining = 60;
        this.timer = window.setInterval(() => {
          this.remaining -= 1;
          if (this.remaining <= 0) window.clearInterval(this.timer);
        }, 1000);
        message.success('验证码已发送');
      } catch (error) {
        message.error(error.message || '验证码发送失败');
      } finally {
        this.sending = false;
      }
    },
    async submit() {
      if (this.busy || this.sending) return;
      if (this.codeEnv !== (localStorage.getItem('curEnv') || '')) {
        message.error('环境已切换，请重新获取验证码');
        return;
      }
      if (!this.codeId || this.form.phone.trim() !== this.codePhone) {
        message.error('请先为当前手机号获取验证码');
        return;
      }
      if (!/^\d{6}$/.test(this.form.verifyCode)) {
        message.error('请输入六位验证码');
        return;
      }
      this.busy = true;
      let navigating = false;
      try {
        rmToken();
        await loginUnifiedSms({
          phone: this.codePhone,
          verifyCode: this.form.verifyCode,
          codeId: this.codeId,
        });
        this.form.verifyCode = '';
        this.$store.commit('emptyTab');
        // 新登录会话使用全新页面，清除 qiankun 缓存的旧身份和子应用模块。
        window.location.replace('/');
        navigating = true;
      } catch (error) {
        message.error(error.message || '登录失败，请重新获取验证码');
      } finally {
        // 请求失败也可能已消费验证码，不允许再次提交同一个 codeId。
        this.codeId = '';
        if (!navigating) this.busy = false;
      }
    },
  },
};
</script>
